import React from 'react'
import QuerySuspenseBoundary from './QuerySuspenseBoundary'

export * from './QuerySuspenseBoundary'
export default React.memo(QuerySuspenseBoundary)
